import { render, staticRenderFns } from "./SpecialFunctionType.vue?vue&type=template&id=5198e96e&"
import script from "./SpecialFunctionType.vue?vue&type=script&lang=js&"
export * from "./SpecialFunctionType.vue?vue&type=script&lang=js&"
import style0 from "./SpecialFunctionType.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports